import { render } from "./video-element.vue?vue&type=template&id=68befe9c"
import script from "./video-element.vue?vue&type=script&lang=js"
export * from "./video-element.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__